import { makeRoute } from '~/utils/route';

export default makeRoute({
	path:        '/file-transfer',
	title:       'menu.file-transfer',
	// @ts-ignore
	redirectTo:  () => {
		window.location.href = '/front5/file-transfer';
	},
});
